const phoneRegex = /^([+]1)?[(]?[2-9][0-9]{2}[)]?[-\s.]?[2-9][0-9]{2}[-\s.]?[0-9]{4}$/im;

export default phoneRegex;
